// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"123": "5dfb3cee9a28daa9","507": "c1f1b97b3685f723","803": "7838676ed21aa80b","959": "35bc046409dc248e",}[chunkId] + ".css"
}